import { render } from "./ViewBridge.vue?vue&type=template&id=800b18d6&scoped=true"
import script from "./ViewBridge.vue?vue&type=script&lang=js"
export * from "./ViewBridge.vue?vue&type=script&lang=js"

import "./ViewBridge.vue?vue&type=style&index=0&id=800b18d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800b18d6"]])

export default __exports__